module.exports = __webpack_public_path__ + "7bdccfe06cbbc4be2a08ef06a9c7c259.pdf";